import { useEffect, useRef, useState } from 'react';

const WHATSAPP_URL = 'https://wa.me/5519988179126?text=Ol%C3%A1!%20Quero%20saber%20mais%20sobre%20as%20turmas%20da%20Escola%20Turminha%20da%20Alegria.';

const turmas = [
  {
    icon: 'ri-baby-line',
    color: 'text-vermelho',
    bg: 'bg-vermelho',
    lightBg: 'bg-vermelho/10',
    title: 'Berçário',
    age: '4 meses a 1 ano e 11 meses',
    desc: 'Um espaço especialmente preparado para os bebês, com ambiente aconchegante, seguro e estimulante. Nossa equipe é treinada para oferecer cuidado integral com muito carinho.',
    tags: ['Estimulação sensorial', 'Cuidado integral'],
    img: 'https://storage.readdy-site.link/project_files/f6b15bb9-0a9f-496b-9ad9-42176d58e2ec/96247e39-5f66-4d63-bd34-f38daa21ba8f_20251110_092734.jpg?v=888692db8750132edcaff277e099c77d',
  },
  {
    icon: 'ri-book-open-line',
    color: 'text-azul-medio',
    bg: 'bg-azul-medio',
    lightBg: 'bg-azul-medio/10',
    title: 'Educação Infantil',
    age: '2 a 5 anos',
    desc: 'Turmas estruturadas para o desenvolvimento cognitivo, motor e social da criança, com atividades lúdicas, pedagógicas e princípios cristãos que formam o caráter.',
    tags: ['Alfabetização', 'Matemática lúdica', 'Artes e música'],
    img: 'https://storage.readdy-site.link/project_files/f6b15bb9-0a9f-496b-9ad9-42176d58e2ec/9b1bf10e-ad59-4ebf-acb4-13003cec61c0_20251110_092834.jpg?v=6918d9880fe397e9e1ac2136417a9b94',
  },
  {
    icon: 'ri-sun-line',
    color: 'text-azul-escuro',
    bg: 'bg-azul-escuro',
    lightBg: 'bg-azul-escuro/10',
    title: 'Contra Turno',
    age: 'Até 7 anos',
    desc: 'Para famílias que precisam de suporte no período contrário às aulas. Oferecemos reforço escolar, recreação orientada, descanso e alimentação em ambiente seguro e supervisionado.',
    tags: ['Reforço escolar', 'Recreação', 'Alimentação inclusa'],
    img: 'https://storage.readdy-site.link/project_files/f6b15bb9-0a9f-496b-9ad9-42176d58e2ec/f058848b-2550-4d54-b104-2ad16eb78744_20251110_093905.jpg?v=97fb2ce0a0ea7d5801d9363e9e6a8e69',
  },
];

export default function Turmas() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const [mobileIndex, setMobileIndex] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const prevCard = () => setMobileIndex((i) => (i - 1 + turmas.length) % turmas.length);
  const nextCard = () => setMobileIndex((i) => (i + 1) % turmas.length);

  return (
    <section id="turmas" className="py-24 bg-cinza" ref={ref}>
      <div className="max-w-7xl mx-auto px-6">
        <div className={`text-center mb-16 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="inline-block bg-azul-claro/20 text-azul-escuro font-body font-700 text-sm px-4 py-1.5 rounded-full mb-4">
            Nossas Turmas
          </span>
          <h4 id="turmas-section">
            <a className="font-heading text-[#0D0D0D] text-3xl lg:text-4xl block">
              Turmas para cada fase do seu filho
            </a>
          </h4>
          <p className="font-body text-gray-500 text-base mt-4 max-w-xl mx-auto">
            Cada turma é pensada para atender às necessidades específicas de cada faixa etária com amor e dedicação.
          </p>
        </div>

        {/* Desktop Grid */}
        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {turmas.map((turma, i) => (
            <div
              key={turma.title}
              className={`bg-white rounded-3xl overflow-hidden hover:shadow-md transition-all duration-300 hover:-translate-y-1 group ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={turma.img}
                  alt={`${turma.title} – Escola Infantil Turminha da Alegria`}
                  title={`${turma.title} em escola infantil de Campinas`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{ objectPosition: 'center 60%' }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                <div className={`absolute top-4 left-4 w-10 h-10 flex items-center justify-center ${turma.bg} rounded-xl`}>
                  <i className={`${turma.icon} text-white text-lg`} />
                </div>
              </div>
              <div className="p-6">
                <span className={`inline-block ${turma.lightBg} ${turma.color} font-body text-xs font-700 px-3 py-1 rounded-full mb-3`}>
                  {turma.age}
                </span>
                <h5 className="font-heading text-[#0D0D0D] text-xl mb-3">{turma.title}</h5>
                <p className="font-body text-gray-500 text-sm leading-relaxed mb-4">{turma.desc}</p>
                <div className="flex flex-wrap gap-2 mb-5">
                  {turma.tags.map((tag) => (
                    <span key={tag} className="bg-cinza font-body text-gray-500 text-xs px-3 py-1 rounded-full">
                      {tag}
                    </span>
                  ))}
                </div>
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-full flex items-center justify-center gap-2 ${turma.bg} text-white font-body font-700 text-sm py-3 rounded-xl hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap`}
                >
                  Saiba mais
                  <i className="ri-arrow-right-line" />
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile Carousel */}
        <div className="md:hidden">
          <div className="relative overflow-hidden">
            <div
              className="flex transition-transform duration-400 ease-in-out"
              style={{ transform: `translateX(-${mobileIndex * 100}%)` }}
            >
              {turmas.map((turma) => (
                <div
                  key={turma.title}
                  className="min-w-full px-1"
                >
                  <div className="bg-white rounded-3xl overflow-hidden">
                    <div className="relative h-52 overflow-hidden">
                      <img
                        src={turma.img}
                        alt={`${turma.title} – Escola Infantil Turminha da Alegria`}
                        title={`${turma.title} em escola infantil de Campinas`}
                        className="w-full h-full object-cover"
                        style={{ objectPosition: 'center 60%' }}
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                      <div className={`absolute top-4 left-4 w-10 h-10 flex items-center justify-center ${turma.bg} rounded-xl`}>
                        <i className={`${turma.icon} text-white text-lg`} />
                      </div>
                    </div>
                    <div className="p-6">
                      <span className={`inline-block ${turma.lightBg} ${turma.color} font-body text-xs font-700 px-3 py-1 rounded-full mb-3`}>
                        {turma.age}
                      </span>
                      <h5 className="font-heading text-[#0D0D0D] text-xl mb-3">{turma.title}</h5>
                      <p className="font-body text-gray-500 text-sm leading-relaxed mb-4">{turma.desc}</p>
                      <div className="flex flex-wrap gap-2 mb-5">
                        {turma.tags.map((tag) => (
                          <span key={tag} className="bg-cinza font-body text-gray-500 text-xs px-3 py-1 rounded-full">
                            {tag}
                          </span>
                        ))}
                      </div>
                      <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`w-full flex items-center justify-center gap-2 ${turma.bg} text-white font-body font-700 text-sm py-3 rounded-xl hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap`}
                      >
                        Saiba mais
                        <i className="ri-arrow-right-line" />
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Mobile Navigation */}
          <div className="flex items-center justify-center gap-4 mt-6">
            <button
              onClick={prevCard}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-white border border-gray-200 hover:bg-gray-50 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-xl text-gray-600" />
            </button>

            <div className="flex gap-2">
              {turmas.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setMobileIndex(i)}
                  className={`transition-all duration-300 rounded-full cursor-pointer ${
                    i === mobileIndex ? 'w-6 h-3 bg-azul-escuro' : 'w-3 h-3 bg-gray-300'
                  }`}
                />
              ))}
            </div>

            <button
              onClick={nextCard}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-white border border-gray-200 hover:bg-gray-50 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-xl text-gray-600" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
